const extractPropetryValue = (obj, property) => {
  if (!property.includes('.')) {
    return obj[property];
  }

  const paths = property.split('.');
  const depth = paths.length;
  let tmp = obj;
  let path;
  for (let level = 0; level < depth; level++) {
    path = paths[level];
    if (isArray(path)) {
      tmp = extractArrayItem(tmp, path);
    } else {
      tmp = tmp[path];
    }
  }

  return tmp;
}

const isArray = (property) => {
  return property.includes(']');
}

const extractArrayItem = (object, property) => {
  const startBracket = property.indexOf('[');
  const arrayName = property.substring(0, startBracket);
  const indexValue = property.substring(startBracket + 1, property.length - 1);

  return object[arrayName][indexValue];
}

export default extractPropetryValue;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/utils/property-extractor.js